"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGuardId = exports.memo = exports.collect = exports.merge = exports.projectFieldWithEnv = exports.projectField = exports.mapRecord = void 0;
var tslib_1 = require("tslib");
var Record_1 = require("fp-ts/Record");
/**
 *  @since 0.0.1
 */
var mapRecord = function (d, f) { return Record_1.record.map(d, f); };
exports.mapRecord = mapRecord;
/**
 *  @since 0.0.1
 */
var projectField = function (t) { return function (k) {
    return Record_1.record.map(t, function (p) { return p[k]; });
}; };
exports.projectField = projectField;
/**
 *  @since 0.0.1
 */
var projectFieldWithEnv = function (t, env) { return function (k) {
    return Record_1.record.map(t, function (p) { return p(env)[k]; });
}; };
exports.projectFieldWithEnv = projectFieldWithEnv;
/**
 *  @since 0.0.1
 */
var merge = function () {
    var x = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        x[_i] = arguments[_i];
    }
    return Object.assign.apply(Object, tslib_1.__spreadArrays([{}], x));
};
exports.merge = merge;
/**
 *  @since 0.0.1
 */
var collect = function (d, f) { return Record_1.collect(f)(d); };
exports.collect = collect;
/**
 *  @since 0.0.1
 */
var memo = function (get) {
    var cache = undefined;
    return (function () {
        if (cache === undefined) {
            cache = get();
        }
        return cache;
    });
};
exports.memo = memo;
/**
 *  @since 0.0.1
 *
 * Returns a function returning the index of the first guard matching a particular Objet
 * Caching the result under the given Symbol inside the Object
 */
var getGuardId = function (guards, sym) {
    var len = guards.length;
    return function (a) {
        var isObj = typeof a === 'object' && a !== null;
        if (isObj) {
            var r = a[sym];
            if (r !== undefined) {
                return r;
            }
        }
        for (var i = 0; i < len; i++) {
            if (guards[i](a)._tag === 'Right') {
                if (isObj) {
                    a[sym] = i;
                }
                return i;
            }
        }
        return -1;
    };
};
exports.getGuardId = getGuardId;
